import index from './SatelliteForm';

export default index;
